<form [formGroup]="form">
    <rask-selector
        class="col-7"
        label="{{'LEVERANTORSORDER_DETAIL_HVKODLEV' | translate}}"
        [reverseLookup]="false"
        [search]="searchLeverantor"
        [viewFormatter]="leverantorViewFormatter"
        formControlName="leverantor"
        aid="leverantor"
        [rule]="validation.leverantor"
        [required]="true">
    </rask-selector>
    <rask-radiobutton-group
        label="{{'LEVERANTORSORDER_DETAIL_STATUS' | translate}}"
        [buttons]="statusButtons"
        formControlName="status"
        aid="status">
    </rask-radiobutton-group>
    <rask-header size="3" underline>{{"LEVERANTORSORDER_DETAIL_NYLEV" | translate}}</rask-header>
    <rask-leverantorsorderrad-create
        [enableCommands]="false"
        (modelCreated)="onModelCreated($event)"
        [rootForm]="form"
        [order]="levorder">
    </rask-leverantorsorderrad-create>
</form>
<div class="buttons">
    <rask-save-button [disabled]="!canSave()" (click)="save()"></rask-save-button>
    <rask-button color="secondary" (click)="close()">Avbryt</rask-button>
</div>
